import { Vacancy } from '../types/VacancyTypes';

export const mockVacancies: Vacancy[] = [
  {
    id: 'v1',
    title: 'Senior Backend Engineer',
    company_name: 'Stripe',
    description: 'We are looking for a Senior Backend Engineer to work on our payments infrastructure. You will design and implement scalable systems processing billions of dollars in transactions.',
    requirements: '5+ years backend experience, proficiency in Go or Java, distributed systems knowledge',
    bounty_amount: 5000,
    bounty_currency: 'USD',
    location: 'San Francisco, CA',
    is_remote: true,
    employment_type: 'full-time',
    posted_by: 'user1',
    posted_by_name: 'Alice Johnson',
    is_verified_poster: true,
    status: 'open',
    referral_count: 3,
    created_at: '2026-02-20T10:00:00Z',
    updated_at: '2026-02-20T10:00:00Z',
  },
  {
    id: 'v2',
    title: 'Product Manager',
    company_name: 'Notion',
    description: 'Join our product team to define and ship features that millions of users love. Work cross-functionally with engineering, design, and data teams.',
    requirements: '3+ years PM experience, strong analytical skills, experience with productivity tools',
    bounty_amount: 4000,
    bounty_currency: 'USD',
    location: 'New York, NY',
    is_remote: true,
    employment_type: 'full-time',
    posted_by: 'user2',
    posted_by_name: 'Bob Smith',
    is_verified_poster: true,
    status: 'open',
    referral_count: 7,
    created_at: '2026-02-19T14:30:00Z',
    updated_at: '2026-02-19T14:30:00Z',
  },
  {
    id: 'v3',
    title: 'Frontend Engineer',
    company_name: 'Figma',
    description: 'Help build the future of design tools. Work on our web application using React and TypeScript to create delightful collaborative experiences.',
    requirements: 'Strong React/TypeScript skills, experience with canvas/WebGL a plus',
    bounty_amount: 3500,
    bounty_currency: 'USD',
    location: 'San Francisco, CA',
    is_remote: false,
    employment_type: 'full-time',
    posted_by: 'user3',
    posted_by_name: 'Carol Williams',
    is_verified_poster: true,
    status: 'open',
    referral_count: 5,
    created_at: '2026-02-18T09:00:00Z',
    updated_at: '2026-02-18T09:00:00Z',
  },
  {
    id: 'v4',
    title: 'DevOps Engineer',
    company_name: 'Datadog',
    description: 'Scale our monitoring infrastructure to handle trillions of data points. Work with Kubernetes, Terraform, and cloud-native technologies.',
    requirements: 'Experience with K8s, Terraform, AWS/GCP, CI/CD pipelines',
    bounty_amount: 4500,
    bounty_currency: 'USD',
    location: 'Remote',
    is_remote: true,
    employment_type: 'full-time',
    posted_by: 'user4',
    posted_by_name: 'Dave Brown',
    is_verified_poster: false,
    status: 'open',
    referral_count: 2,
    created_at: '2026-02-17T16:00:00Z',
    updated_at: '2026-02-17T16:00:00Z',
  },
  {
    id: 'v5',
    title: 'Data Scientist',
    company_name: 'Spotify',
    description: 'Use machine learning to improve music recommendations for 500M+ users. Work on personalization algorithms and content understanding.',
    requirements: 'PhD or MS in CS/Stats, Python, ML frameworks, large-scale data processing',
    bounty_amount: 6000,
    bounty_currency: 'USD',
    location: 'Stockholm, Sweden',
    is_remote: true,
    employment_type: 'full-time',
    posted_by: 'user5',
    posted_by_name: 'Eva Lindqvist',
    is_verified_poster: true,
    status: 'open',
    referral_count: 1,
    created_at: '2026-02-16T11:00:00Z',
    updated_at: '2026-02-16T11:00:00Z',
  },
  {
    id: 'v6',
    title: 'iOS Developer',
    company_name: 'Revolut',
    description: 'Build financial features used by millions. Work on our iOS app using Swift and SwiftUI. Ship features that directly impact how people manage money.',
    requirements: '3+ years iOS development, Swift, SwiftUI, fintech experience preferred',
    bounty_amount: 3000,
    bounty_currency: 'GBP',
    location: 'London, UK',
    is_remote: false,
    employment_type: 'full-time',
    posted_by: 'user6',
    posted_by_name: 'Frank Miller',
    is_verified_poster: true,
    status: 'open',
    referral_count: 4,
    created_at: '2026-02-15T08:30:00Z',
    updated_at: '2026-02-15T08:30:00Z',
  },
  {
    id: 'v7',
    title: 'UX Designer',
    company_name: 'Canva',
    description: 'Design intuitive interfaces for our visual design platform. Collaborate with product and engineering to create experiences that empower creativity.',
    requirements: 'Portfolio demonstrating strong UX skills, Figma proficiency, user research experience',
    bounty_amount: 2500,
    bounty_currency: 'USD',
    location: 'Sydney, Australia',
    is_remote: true,
    employment_type: 'full-time',
    posted_by: 'user7',
    posted_by_name: 'Grace Lee',
    is_verified_poster: false,
    status: 'open',
    referral_count: 0,
    created_at: '2026-02-14T13:00:00Z',
    updated_at: '2026-02-14T13:00:00Z',
  },
  {
    id: 'v8',
    title: 'Machine Learning Engineer',
    company_name: 'OpenAI',
    description: 'Work on cutting-edge AI systems. Help build and deploy large language models and other AI technologies that push the frontier of what is possible.',
    requirements: 'Strong ML background, PyTorch, distributed training experience, publications a plus',
    bounty_amount: 10000,
    bounty_currency: 'USD',
    location: 'San Francisco, CA',
    is_remote: false,
    employment_type: 'full-time',
    posted_by: 'user8',
    posted_by_name: 'Henry Chen',
    is_verified_poster: true,
    status: 'open',
    referral_count: 12,
    created_at: '2026-02-13T10:00:00Z',
    updated_at: '2026-02-13T10:00:00Z',
  },
  {
    id: 'v9',
    title: 'Security Engineer',
    company_name: 'CrowdStrike',
    description: 'Protect organizations from cyber threats. Work on endpoint detection, threat intelligence, and incident response tooling.',
    requirements: 'Security background, experience with EDR, threat hunting, scripting in Python',
    bounty_amount: 5000,
    bounty_currency: 'USD',
    location: 'Austin, TX',
    is_remote: true,
    employment_type: 'full-time',
    posted_by: 'user9',
    posted_by_name: 'Irene Davis',
    is_verified_poster: false,
    status: 'open',
    referral_count: 1,
    created_at: '2026-02-12T15:30:00Z',
    updated_at: '2026-02-12T15:30:00Z',
  },
  {
    id: 'v10',
    title: 'Full Stack Developer (Contract)',
    company_name: 'Toptal Client',
    description: 'Join a fast-paced startup building an e-commerce platform. Work with React, Node.js, and PostgreSQL. 6-month contract with potential to extend.',
    requirements: 'React, Node.js, PostgreSQL, 3+ years experience',
    bounty_amount: 2000,
    bounty_currency: 'USD',
    location: 'Remote',
    is_remote: true,
    employment_type: 'contract',
    posted_by: 'user10',
    posted_by_name: 'Jack Wilson',
    is_verified_poster: false,
    status: 'open',
    referral_count: 0,
    created_at: '2026-02-11T09:00:00Z',
    updated_at: '2026-02-11T09:00:00Z',
  },
  {
    id: 'v11',
    title: 'Engineering Manager',
    company_name: 'Airbnb',
    description: 'Lead a team of 8-10 engineers building the search and discovery experience. Drive technical strategy and grow your team members careers.',
    requirements: '5+ years engineering, 2+ years management, strong communication skills',
    bounty_amount: 7500,
    bounty_currency: 'USD',
    location: 'San Francisco, CA',
    is_remote: false,
    employment_type: 'full-time',
    posted_by: 'user11',
    posted_by_name: 'Karen Martinez',
    is_verified_poster: true,
    status: 'open',
    referral_count: 6,
    created_at: '2026-02-10T12:00:00Z',
    updated_at: '2026-02-10T12:00:00Z',
  },
  {
    id: 'v12',
    title: 'Rust Developer',
    company_name: 'Cloudflare',
    description: 'Help build the next generation of internet infrastructure. Work on high-performance networking code serving millions of requests per second.',
    requirements: 'Rust proficiency, systems programming, networking knowledge',
    bounty_amount: 5500,
    bounty_currency: 'USD',
    location: 'London, UK',
    is_remote: true,
    employment_type: 'full-time',
    posted_by: 'user12',
    posted_by_name: 'Leo Thomas',
    is_verified_poster: true,
    status: 'open',
    referral_count: 3,
    created_at: '2026-02-09T14:00:00Z',
    updated_at: '2026-02-09T14:00:00Z',
  },
  {
    id: 'v13',
    title: 'QA Automation Engineer',
    company_name: 'Shopify',
    description: 'Build and maintain automated test suites for our e-commerce platform. Work with Selenium, Cypress, and CI/CD pipelines.',
    requirements: 'Cypress/Selenium experience, CI/CD knowledge, attention to detail',
    bounty_amount: 2500,
    bounty_currency: 'CAD',
    location: 'Ottawa, Canada',
    is_remote: true,
    employment_type: 'full-time',
    posted_by: 'user13',
    posted_by_name: 'Maria Garcia',
    is_verified_poster: false,
    status: 'open',
    referral_count: 0,
    created_at: '2026-02-08T10:30:00Z',
    updated_at: '2026-02-08T10:30:00Z',
  },
  {
    id: 'v14',
    title: 'Platform Engineer',
    company_name: 'Palantir',
    description: 'Build platform services that power mission-critical applications for governments and enterprises. Work on distributed systems at scale.',
    requirements: 'Java/Go, distributed systems, Kubernetes, security clearance a plus',
    bounty_amount: 8000,
    bounty_currency: 'USD',
    location: 'Washington, DC',
    is_remote: false,
    employment_type: 'full-time',
    posted_by: 'user14',
    posted_by_name: 'Nathan Park',
    is_verified_poster: true,
    status: 'open',
    referral_count: 2,
    created_at: '2026-02-07T11:00:00Z',
    updated_at: '2026-02-07T11:00:00Z',
  },
  {
    id: 'v15',
    title: 'Technical Writer (Part-time)',
    company_name: 'Vercel',
    description: 'Create clear, engaging documentation for our developer platform. Work closely with engineering to document APIs, SDKs, and deployment guides.',
    requirements: 'Technical writing experience, understanding of web development, excellent English',
    bounty_amount: 1000,
    bounty_currency: 'USD',
    location: 'Remote',
    is_remote: true,
    employment_type: 'part-time',
    posted_by: 'user15',
    posted_by_name: 'Olivia White',
    is_verified_poster: false,
    status: 'open',
    referral_count: 0,
    created_at: '2026-02-06T08:00:00Z',
    updated_at: '2026-02-06T08:00:00Z',
  },
];
